/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'
import { BackButton } from './BackButton'

export type HeaderProps = {
  title: string
  onBack?: (e: any) => void
}

export const Header = ({ title, onBack }: HeaderProps) => {
  return (
    <div css={headerStyle}>
      <BackButton onClick={onBack} />
      <h1>{title}</h1>
    </div>
  )
}

const headerStyle = css`
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  margin-top: 15px;

  h1 {
    font-weight: bold;
    font-size: 18px;
    line-height: 100%;
    text-align: center;
    letter-spacing: 0.1em;
  }

  button {
    position: absolute;
    left: 15px;
  }
`
